import { withFormik, useField  } from 'formik';
import { defaultFormSubmit } from 'src/utils/form/submit';
import SignInForm from './SignInForm';
import schema from './schema';

export default withFormik({
  validationSchema: schema.validation,
  mapPropsToValues: () => ({
    email: '',
    password: '',
    rememberMe: true,
  }),
  handleSubmit: (values, form, errors) => {
    return defaultFormSubmit(values, form, schema.requireValues, errors);
  },
  validateOnBlur: false,
  validateOnChange: true,
  displayName: 'SignInForm',
})(SignInForm);
